import styled, { css } from "styled-components";

interface EditAddressStyledProps {
  fontColorTheme?: "dark" | "light";
  mobileReductionEnabled?: boolean;
}

export const EditAddressStyled = styled.div.attrs({
  className: "edit-address",
})<EditAddressStyledProps>`
  ${({ theme, fontColorTheme, mobileReductionEnabled }) => {
    const { colors = {}, media = {} } = theme;
    const fontColor = fontColorTheme === "dark" ? colors.primary.darkBlue : colors.primary.white;
    return css`
      ${media.mobile.down} {
        text-align: center;
        margin-bottom: 24px;
      }

      .edit-address {
        &__quote_number {
          font-size: ${mobileReductionEnabled ? "14px" : "16px"};
          font-weight: ${mobileReductionEnabled ? "400" : "700"};
          line-height: ${mobileReductionEnabled ? "20px" : "24px"};
        }

        &__quote-label {
          font-weight: ${mobileReductionEnabled ? "700" : "inherit"};
        }

        &__title {
          align-items: center;
          color: ${fontColor};
          display: flex;
          font-size: ${mobileReductionEnabled ? "14px" : "1rem"};
          font-weight: ${mobileReductionEnabled ? "700" : "500"};
          justify-content: center;
          line-height: ${mobileReductionEnabled ? "20px" : "16px"};
          margin-top: 16px;
          margin-bottom: ${mobileReductionEnabled ? "0" : "0.5rem"};

          ${media.tablet.up} {
            justify-content: flex-start;
          }

          span {
            color: ${fontColor};
          }

          svg {
            display: inline-block;
            height: 22px;
            margin-right: 0.5rem;
            position: relative;
            top: 1px;

            path {
              fill: ${fontColor};
            }
          }
        }

        &__button {
          background: none;
          border: 0;
          color: ${fontColor};
          cursor: pointer;
          font-size: ${mobileReductionEnabled ? "14px" : "1rem"};
          line-height: ${mobileReductionEnabled ? "20px" : "17px"};
          padding: 0;
          margin: 0;

          span {
            color: ${fontColor};
            font-size: inherit;
            line-height: inherit;
            font-weight: 500;
            margin-left: 5px;
            text-decoration: underline;
          }
        }
      }
    `;
  }}
`;

export const EditAddressQuoteStyled = styled.div<{
  showSaveQuoteButton?: boolean;
  mobileReductionEnabled?: boolean;
}>`
  ${({ theme, showSaveQuoteButton, mobileReductionEnabled }) => {
    const { media = {} } = theme;
    return css`
      ${mobileReductionEnabled &&
      css`
        font-size: 14px;
        line-height: 20px;
      `}

      ${showSaveQuoteButton &&
      css`
        display: flex;
        align-items: center;
        gap: 10px;
        justify-content: center;
        flex-direction: column;

        ${media.tablet.up} {
          flex-direction: row;
        }
      `}
    `;
  }}
`;
